import { CPLAT_API_ROUTES, useFetch } from '@/api';
import { IconAlarmInfo, ReviewStars } from '@/assets/icons/Dashboard';
import { useLog } from '@/hooks/V3/useLog';
import { useAppSelector } from '@/redux/store';
import { deviceUuidState } from '@/store/atom';
import { CplatApiResponse } from '@/types/api';
import moment from 'moment';
import { useRecoilValue } from 'recoil';
import { DashboardCard } from '../card';
import ReviewInquiryStatusCard from './ReviewInquiryStatusCard';

const ReviewInquiryStatus = () => {
  const { UserNo } = useAppSelector((state) => state.user);
  const { setUserEventHistory } = useLog(UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);

  const today = moment();
  const aWeekAgo = moment().add('day', -7);

  const user = useAppSelector((state) => state.user);

  const { data } = useFetch<
    CplatApiResponse<
      {
        newReviewCount: 0;
        newInquiryCount: 0;
      }[]
    >
  >(CPLAT_API_ROUTES.getActivitySummary, {
    method: 'POST',
    params: {
      cplatToken: user.CplatToken,
      dateFrom: aWeekAgo.format('YYYY-MM-DD'),
      dateTo: today.format('YYYY-MM-DD'),
    },
    v3: true,
  });

  const countData = data?.data[0];

  const handleReviewInquiryClick = (filter: 'reviews' | 'inquiries') => {
    setUserEventHistory({
      eventName: `${filter}_status_card_web_dashboard`,
      deviceUuid,
    });
  };

  return (
    <DashboardCard>
      <div className="text-gr-900 Body1S16">리뷰/문의</div>
      <div className="flex items-center gap-[52px]">
        <ReviewInquiryStatusCard
          label="리뷰등록"
          count={countData?.newReviewCount ?? 0}
          filter="reviews"
          icon={<ReviewStars />}
          onClickBefore={() => handleReviewInquiryClick('reviews')}
        />
        <ReviewInquiryStatusCard
          label="문의등록"
          count={countData?.newInquiryCount ?? 0}
          filter="inquiries"
          icon={<IconAlarmInfo />}
          onClickBefore={() => handleReviewInquiryClick('inquiries')}
        />
      </div>
    </DashboardCard>
  );
};

export default ReviewInquiryStatus;
